/**
 * Block deprecation
 *
 * @see example block
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { RichText, useBlockProps } from '@wordpress/block-editor';

const v3 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    heading: {
      default: [],
      selector: '.heading-with-paragraph__heading',
      source: 'children',
      type: 'array'
    },
    headingColor: {
      default: '',
      type: 'string'
    },
    text: {
      default: [],
      selector: '.heading-with-paragraph__text',
      source: 'children',
      type: 'array'
    },
    textColor: {
      default: '',
      type: 'string'
    }
  },
  save({ attributes }) {
    const {
      heading,
      headingColor,
      text,
      textColor
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__heading-with-paragraph'
    });

    const showTextBlock = !!( heading.length > 0 || text.length > 0 );
    const hColor = headingColor ? { color: headingColor } : undefined;
    const tColor = textColor ? { color: textColor } : undefined;

    return (
      showTextBlock && (
        <div { ...blockProps }>
          <div className='heading-with-paragraph--inner'>
            { heading.length > 0 && (
              <RichText.Content
                className='heading-2 heading-with-paragraph__heading'
                style={ { ...hColor } }
                tagName='h2'
                value={ heading }
              />
            ) }

            { text.length > 0 && (
              <RichText.Content
                className='paragraph-1 heading-with-paragraph__text'
                style={ { ...tColor } }
                tagName='p'
                value={ text }
              />
            ) }

          </div>
        </div>
      )
    );
  }
};
const v2 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    heading: {
      default: [],
      selector: '.heading-with-paragraph__heading',
      source: 'children',
      type: 'array'
    },
    headingColor: {
      default: '',
      type: 'string'
    },
    text: {
      default: [],
      selector: '.heading-with-paragraph__text',
      source: 'children',
      type: 'array'
    },
    textColor: {
      default: '',
      type: 'string'
    }
  },
  save({ attributes }) {
    const {
      heading,
      headingColor,
      text,
      textColor
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__heading-with-paragraph'
    });

    const showTextBlock = !!( heading.length > 0 || text.length > 0 );
    const hColor = headingColor ? { color: headingColor } : undefined;
    const tColor = textColor ? { color: textColor } : undefined;

    return (
      showTextBlock && (
        <div { ...blockProps }>
          <div className='heading-with-paragraph--inner'>
            { heading.length > 0 && (
              <RichText.Content
                className='heading-2 heading-with-paragraph__heading'
                style={ { ...hColor } }
                tagName='h2'
                allowedFormats={ [ 'core/bold', 'core/italic' ] }
                value={ heading }
              />
            ) }

            { text.length > 0 && (
              <RichText.Content
                className='paragraph-1 heading-with-paragraph__text'
                style={ { ...tColor } }
                tagName='p'
                value={ text }
              />
            ) }

          </div>
        </div>
      )
    );
  }
};
const v1 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    heading: {
      default: [],
      selector: '.heading-with-paragraph__heading',
      source: 'children',
      type: 'array'
    },
    headingColor: {
      default: '',
      type: 'string'
    },
    text: {
      default: [],
      selector: '.heading-with-paragraph__text',
      source: 'children',
      type: 'array'
    },
    textColor: {
      default: '',
      type: 'string'
    }
  },
  save({ attributes }) {
    const {
      heading,
      headingColor,
      text,
      textColor
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__heading-with-paragraph'
    });

    const showTextBlock = !!( heading.length > 0 || text.length > 0 );
    const hColor = headingColor ? { color: headingColor } : undefined;
    const tColor = textColor ? { color: textColor } : undefined;

    return (
      showTextBlock && (
        <div { ...blockProps }>
          <div className='heading-with-paragraph--inner flex flex-col w-full gap-25 lg:gap-32'>
            { heading.length > 0 && (
              <RichText.Content
                className='heading-2 heading-with-paragraph__heading text-black break-normal'
                style={ { ...hColor } }
                tagName='h2'
                allowedFormats={ [ 'core/bold', 'core/italic' ] }
                value={ heading }
              />
            ) }

            { text.length > 0 && (
              <RichText.Content
                className='paragraph-1 heading-with-paragraph__text text-black break-normal'
                style={ { ...tColor } }
                tagName='p'
                value={ text }
              />
            ) }

          </div>
        </div>
      )
    );
  }
};

export default [ v3, v2, v1 ];
